export const insightsFlushTopic = 'insights.flush';
export const featureFlagEvaluatedTopic = 'featureflag.evaluated.topic';
export const featureFlagEvaluatedBufferTopic = 'featureflag.evaluated.buffer.topic';
export const websocketReconnectTopic = 'network.websocket.reconnect';
export const debugModeQueryStr = 'debugmode'; // will print debug logs if true
export const insightsTopic = 'insights.topic';
export const currentUserStorageKey = 'fb-user';
